import * as Subsidiaries from '../services/Subsidiaries'

export const RECEIVE_SUBSIDIARIES = 'RECEIVE_SUBSIDIARIES'
export const RECEIVE_SUBSIDIARY = 'RECEIVE_SUBSIDIARY'

function receiveSubsidiaries(state, subsidiaries) {
  return {
    type: RECEIVE_SUBSIDIARIES,
    subsidiaries
  }
}

export const fetchSubsidiaries = () => (dispatch, getState) => {
  const state = getState()
  Subsidiaries.all().then((data) => dispatch(receiveSubsidiaries(state, data)))
}

function receiveSubsidiary(state, subsidiary) {
  return {
    type: RECEIVE_SUBSIDIARY,
    subsidiary: subsidiary ? subsidiary : {id: -1}
  }
}

export const fetchSubsidiary = (id) => (dispatch, getState) => {
  const state = getState()
  Subsidiaries.get(id).then((data) => dispatch(receiveSubsidiary(state, data)))
}

export const updateSubsidiary = (subsidiary) => (dispatch, getState) => {
  return Subsidiaries.update(subsidiary)
}
